import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	BusinessUser,
	BusinessUserRole,
	BusinessUserStatus,
} from '@models/businesses';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { DropdownResult } from '../../atomic/atoms/dropdown-options/dropdown-options.component';
import { ICON } from '@core/util/icon';
import { cloneDeep } from 'lodash';

@UntilDestroy()
@Component({
	selector: 'app-business-user-select-dropdown',
	templateUrl: './business-user-select-dropdown.component.html',
	standalone: false,
})
export class BusinessUserSelectDropdownComponent {
	public users: BusinessUser[];
	public ICON = ICON;
	public showOptions = false;
	noneOption: BusinessUser = {
		firstName: 'None',
		lastName: '',
		role: BusinessUserRole.CLERK,
		admin: false,
		dashboardFilter: undefined,
		email: '',
		status: BusinessUserStatus.ACTIVE,
		teranetUsername: '',
		treefortDisclaimerRead: false,
		userUid: '',
		userBusinessId: '',
		userBusinessName: '',
		lastAccessTime: 0,
	};

	@Select(BusinessUsersState.getLawyers) lawyers$: Observable<BusinessUser[]>;
	@Select(BusinessUsersState.getClerks) clerks$: Observable<BusinessUser[]>;

	@Input() selectedUserId: string;

	@Input() xposition: 'left' | 'right' = 'right';
	@Input() disabled = false;

	@Input() set role(role: BusinessUserRole) {
		if (role === BusinessUserRole.CLERK) {
			this.clerks$.pipe(untilDestroyed(this)).subscribe((clerks) => {
				// Add 'None' option to the Clerk dropdown
				const _clerks = [this.noneOption, ...clerks];
				this.users = cloneDeep(_clerks);
			});
		} else if (role === BusinessUserRole.LAWYER) {
			this.lawyers$.pipe(untilDestroyed(this)).subscribe((lawyers) => {
				this.users = lawyers;
			});
		}
	}

	@Output() selected: EventEmitter<BusinessUser> = new EventEmitter();

	getInitials = (item: BusinessUser): string => {
		let result = '';
		if (item?.firstName?.length > 0) {
			result += item.firstName[0];
		}
		if (item?.lastName?.length > 0) {
			result += item.lastName[0];
		}

		return result;
	};

	_selected = (selected: DropdownResult<BusinessUser>) => {
		this.showOptions = false;
		this.selected.emit(selected.result);
	};
}
